export const defaultErrorMessage = '[SYNC] COULD_NOT_SYNC_AVATAR'
